import { CDSelector } from "./CDSelector";
import { CDProperty } from "./CDProperty";

export class CSSRuleContainer 
{
  selector:CDSelector;
  properties:CDProperty[];

  constructor() 
  {
    this.selector = null;
    this.properties = [];
  }

  getRule() 
  {
    let output = "";
    let selectorScope = this.selector.selectorScope;
    output += selectorScope;
    output += "\n{\n";
    let isFirst = true;

    for ( let property of this.properties ) 
    {
      if ( isFirst ) 
      {
        isFirst = false;
      }
      else 
      {
        output += "\n";
      }

      if ( ! property.isStatic ) 
      {
        output += "  /* DYNAMIC */";
        output += "\n";
      }

      output += "  ";
      output += property.name + ": ";
      output += property.value + ";";
    }

    output += "\n}\n";
    
    return output;
  }
}